import React, { PropsWithChildren } from 'react';
import { Heading, HeadingHierarchy } from '../Heading/Heading';
import { Help } from '../../Form2/partials/Help/Help';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';

export type BlockBarProps = PropsWithChildren<{
  heading: string;
  position?: string;
  hierarchy?: HeadingHierarchy;
  helpText?: string;
  blockId?: string;
  invisibleHeading?: boolean;
}>;

export function BlockBarBase({
  heading,
  position,
  hierarchy = 2,
  children,
  helpText,
  blockId,
  invisibleHeading,
}: BlockBarProps) {
  const id = useHtmlValidId();
  const headingClassName = invisibleHeading ? 'invisible' : 'block-bar__heading font-bold-15-19';

  return (
    <div id={blockId} className="block-bar">
      <Heading className={headingClassName} hierarchy={hierarchy} aria-describedby={helpText ? id : undefined}>
        {heading}
        {position && <span className="block-bar__heading-position">{position}</span>}
      </Heading>
      {helpText ? (
        <div className="block-bar__help-container">
          <Help id={id} helpText={helpText} tooltipPlacement={TooltipPlacement.TOP} />
        </div>
      ) : null}
      {children}
    </div>
  );
}
